/**
 * Selección rápida de elemento único en el DOM
 */
export function $<T extends HTMLElement = HTMLElement>(selector: string, parent: ParentNode = document): T | null {
  return parent.querySelector<T>(selector);
}

/**
 * Selección rápida de múltiples elementos en el DOM
 */
export function $$<T extends HTMLElement = HTMLElement>(selector: string, parent: ParentNode = document): NodeListOf<T> {
  return parent.querySelectorAll<T>(selector);
}

/**
 * Helper para crear elementos HTML con clases y atributos rápidamente
 */
export function createElement<K extends keyof HTMLElementTagNameMap>(
  tagName: K,
  options?: {
    className?: string;
    id?: string;
    innerHTML?: string;
    attributes?: Record<string, string>;
  }
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tagName);
  if (options) {
    if (options.className) el.className = options.className;
    if (options.id) el.id = options.id;
    if (options.innerHTML !== undefined) el.innerHTML = options.innerHTML;
    if (options.attributes) {
      for (const [key, value] of Object.entries(options.attributes)) {
        el.setAttribute(key, value);
      }
    }
  }
  return el;
}
